import { PaymentMethodForm } from '../../features/payment-method/PaymentMethodForm';

export const PaymentMethodRight = ({ isNew }: { isNew: boolean }) => {
  return <PaymentMethodForm isNew={isNew} />;
};
